import { Button, ButtonType } from '@checkmarx/cx-ui';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { UserEditDialogForm, UserEditFormMode } from '../../../services/enums/users';
import EditUserDialogContainer from '../editUserDialog';

@inject('translationsStore', 'addEditUserStore', 'authenticationProvidersStore') @observer
export default class AddUserButtonContainer extends Component {

    state = {
        showAddUserModal: false,
    };

    closeAddUserModal = (e) => {

        this.setState({ 
            showAddUserModal: false
        });

        const applicationProvider = this.props.authenticationProvidersStore.getApplicationAuthenticationProvider();     
                      
        this.props.addEditUserStore.setAuthenticationProviderId(applicationProvider.id);
        this.props.addEditUserStore.setDefaultAuthenticationProviderType();
        this.props.addEditUserStore.setUserEditDialogForm(UserEditDialogForm.add);
        this.props.addEditUserStore.reset();
    }
    
    openAddUserModal = (e) => {
        
        this.props.addEditUserStore.setFormMode(UserEditFormMode.add);
        
        const applicationProvider = this.props.authenticationProvidersStore.getApplicationAuthenticationProvider();     
                      
        this.props.addEditUserStore.setAuthenticationProviderId(applicationProvider.id);
        this.props.addEditUserStore.setDefaultAuthenticationProviderType();

        this.setState({ 
            showAddUserModal: true
        });
    }

    switchToAddUserFrom = () => {

        this.props.addEditUserStore.setUserEditDialogForm(UserEditDialogForm.add);
    }

    switchToImportLDAPForm = () => {

        this.props.addEditUserStore.setUserEditDialogForm(UserEditDialogForm.importFromDirectory);
    }

    render() {

        return (
            [
                <Button
                    key={1}
                    dataCy='add-user-button'
                    style={{
                        height: 26,
                        lineHeight: '26px',
                        marginRight: '37px'
                    }}
                    onClick={this.openAddUserModal}
                    text={this.props.addUserText}
                />,
                <EditUserDialogContainer
                    key={2}
                    openAddUserModal={this.openAddUserModal}
                    closeAddUserModal={this.closeAddUserModal}
                    switchToAddUserFrom={this.switchToAddUserFrom}
                    switchToImportLDAPForm={this.switchToImportLDAPForm}
                    show={this.state.showAddUserModal}
                    mode={this.props.addEditUserStore.userEditDialogForm}
                />
            ]
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/users/addUserButton/index.jsx